import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'selection', 'count', 'previews'];

  connect() {
    this.previewUrls = [];
  }

  disconnect() {
    this.releasePreviews();
  }

  display() {
    const files = Array.from(this.inputTarget.files);
    this.releasePreviews();
    this.previewsTarget.replaceChildren();
    this.selectionTarget.classList.add('hidden');

    if (!files.length) return;

    // Maximum size per image or video: 200MB, converted to bytes for File.size.
    const maxFileSizeBytes = 200 * 1024 * 1024;
    const invalidFile = files.find(file =>
      !/^(image|video)\//.test(file.type) || file.size > maxFileSizeBytes
    );

    if (invalidFile) {
      this.clear();
      alert(`${invalidFile.name}: select an image or video no larger than 200MB.`);
      return;
    }

    files.forEach(file => {
      const figure = document.createElement('figure');
      const preview = document.createElement(file.type.startsWith('image/') ? 'img' : 'video');
      const url = URL.createObjectURL(file);
      this.previewUrls.push(url);
      preview.src = url;
      preview.className = 'object-cover w-full h-32 rounded-md';
      if (preview.tagName === 'VIDEO') {
        preview.controls = true;
        preview.preload = 'metadata';
      } else {
        preview.alt = file.name;
      }
      const caption = document.createElement('figcaption');
      caption.textContent = file.name;
      caption.className = 'truncate text-xs text-gray-500';
      figure.append(preview, caption);
      this.previewsTarget.append(figure);
    });

    this.countTarget.textContent = `${files.length} file${files.length === 1 ? '' : 's'} selected`;
    this.selectionTarget.classList.remove('hidden');
  }

  clear() {
    this.inputTarget.value = '';
    this.previewsTarget.replaceChildren();
    this.countTarget.textContent = '';
    this.selectionTarget.classList.add('hidden');
    this.releasePreviews();
  }

  releasePreviews() {
    this.previewUrls.forEach(url => URL.revokeObjectURL(url));
    this.previewUrls = [];
  }
}